import React from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import HeadlineCards from "./components/HeadlineCards";
import Food from "./components/Food";
import Category from "./components/Category";

function App() {
  return (
    <div>
      <Navbar />
      <Hero />
      <HeadlineCards />
      <Food />
      <Category />
      <div className="w-full pt-3 pb-16 text-center font-semibold">
        <p>
          Designed by{" "}
          <a
            href="https://www.mannytechlabs.com/"
            target="_blank"
            rel="noreferrer"
            className="text-blue-500"
          >
            MannyTech Labs
          </a>
        </p>
      </div>
    </div>
  );
}

export default App;
